import { useToast } from "components/atoms/toast/toast-context";
import { useEffect, useState } from "react";
import * as Sentry from "@sentry/nextjs";
import { WretchError } from "wretch";

import { IGetContentForPausedUserResponse } from "services/api/sessions/sessionService.types";
import { getUIContentsForPausedUser } from "services/api/sessions/sessionsService";
import { useAuth } from "stores/auth/auth-context";
import { IUsePauseSubscriptionModal } from "./pause-subscription-modal.types";
import { useKelasLiveContext } from "stores/kelas-live/kelas-live-context";

export const usePauseSubscriptionModal = (): IUsePauseSubscriptionModal => {
  const [isLinkClicked, setIsLinkClicked] = useState(false);
  const [UIContentsForPausedUser, setUIContentsForPausedUser] =
    useState<IGetContentForPausedUserResponse | null>(null);
  const { userSubscription } = useKelasLiveContext();
  const toast = useToast();
  const {
    user: {
      userData: { primary_user }
    }
  } = useAuth();

  type APIErrorResponse = {
    data: unknown;
    message: string;
    errors?: string[];
    meta?: unknown;
  };

  const fetchUIContentsForPausedUser = async () => {
    try {
      const res = await getUIContentsForPausedUser(primary_user.access_token);
      setUIContentsForPausedUser(res);
    } catch (err) {
      const error = err as WretchError & { json?: APIErrorResponse };
      if (
        error.json?.errors?.includes("No paused subscription found") &&
        primary_user?.access_token
      ) {
        userSubscription.fetchSubscriptionStatus(primary_user?.access_token);
      } else {
        Sentry.captureException(err);
        toast.addToast({
          heading: "Ada yang salah",
          variant: "error"
        });
      }
    }
  };

  useEffect(() => {
    fetchUIContentsForPausedUser();
  }, []);

  return {
    UIContentsForPausedUser,
    isLinkClicked,
    setIsLinkClicked
  };
};
